module.exports = __webpack_public_path__ + "static/media/attachment.366349d7.svg";